<template>
    <div id="modal-view">
        <div
            class="modal"
            role="dialog"
            tabindex="-1">
            <div class="modal-dialog modal-dialog-centered" role="document" :class="{'fullscreen': fullScreen}">
                <div class="modal-content bg-transparent border-0" :class="{'fullscreen-content': fullScreen}">
                    <div v-click-outside="hideModal" class="modal-body">
                        <slot name="body">
                        </slot>
                    </div>
                </div>
            </div>
        </div>

        <div class="backdrop" @click="$emit('hide')">
            <slot name="backdrop"></slot>
        </div>
    </div>
</template>

<script lang="ts">
import { ref } from 'vue';
import { useModalStore } from '@/stores';

export default {
    props: {
        fullscreen: {
            type: Boolean,
            default: false,
        },
    },
    setup(props: any, context: any) {
        const fullScreen = ref(props.fullscreen);
        const modalStore = useModalStore();

        function hideModal() {
            modalStore.hideModal();
            context.emit('hide');
        }

        return {
            hideModal,
            fullScreen,
        };
    },
};
</script>

<style scoped lang="scss">
@import "~@/assets/variables";

.modal {
    display: block;
    .fullscreen {
        min-height: unset;
        max-width: unset;
        max-height: unset;
        margin: 15px;
        height: calc(100% - 30px);
        width: calc(100% - 30px);

        .fullscreen-content {
            width: 100%;
            height: 100%;

            .modal-body {
                width: 100%;
                height: 100%;
                padding: 0;
            }
        }
    }

}
</style>
